import Policy from './Policy'

// Backend policies resolved in: backend/components/attendance/app/presenters/attendance/period_presenter.rb
export type AttendancePeriodVerbTypes =
  | 'approvePeriod'
  | 'deletePeriod'
  | 'editPeriod'
  | 'readPeriod'

class AttendancePeriodPolicy extends Policy<AttendancePeriodVerbTypes> {
  checkVerb(verb: AttendancePeriodVerbTypes): boolean {
    switch (verb) {
      case 'approvePeriod':
        return this.permissions.approve

      case 'deletePeriod':
        return this.permissions.delete

      case 'editPeriod':
        return this.permissions.edit

      case 'readPeriod':
        return this.permissions.read

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
    }
  }
}

export default AttendancePeriodPolicy
